<script setup>
import { useId } from 'vue';

defineProps({
    filled: {
        type: Boolean,
        default: false,
    },
});

const maskId = `intercom-news-${useId()}`;
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true"
        class="size-6 shrink-0 text-current">
        <template v-if="filled">
            <path stroke="currentColor" stroke-linecap="round" stroke-width="1.7" fill="none"
                d="M20 4a6.98 6.98 0 0 1 2.101 5c0 1.959-.804 3.73-2.101 5" />
            <mask :id="maskId" fill="#fff">
                <path fill-rule="evenodd"
                    d="M9.5 14h.718l5.231 3.452A1 1 0 0 0 17 16.617V1.858a1 1 0 0 0-1.55-.835L10.937 4H5a5 5 0 0 0-1.923 9.617l1.967 7.212a2.268 2.268 0 0 0 4.456-.597z"
                    clip-rule="evenodd" />
            </mask>
            <path fill="currentColor"
                d="m10.218 14 .936-1.419-.426-.28h-.51zM9.5 14v-1.7H7.8V14zm5.95 3.452-.937 1.42zm0-16.429-.937-1.419zM10.937 4v1.7h.51l.426-.28zm-7.86 9.617 1.64-.447-.22-.802-.766-.32zm1.966 7.212 1.64-.447zm5.174-8.529H9.5v3.4h.718zm6.168 3.733-5.232-3.452L9.28 15.42l5.232 3.452zm-1.086.584a.7.7 0 0 1 1.085-.584l-1.872 2.838c1.795 1.185 4.187-.103 4.187-2.253zm0-14.759v14.76h3.4V1.858zm1.085.584a.7.7 0 0 1-1.085-.584h3.4c0-2.15-2.392-3.438-4.187-2.254zm-4.51 2.977 4.51-2.977-1.872-2.838-4.511 2.977zM5 5.7h5.938V2.3H5zM1.7 9A3.3 3.3 0 0 1 5 5.7V2.3c-3.7 0-6.7 3-6.7 6.7zm2.032 3.048A3.3 3.3 0 0 1 1.7 9h-3.4a6.7 6.7 0 0 0 4.123 6.186zm2.952 8.334L4.718 13.17l-3.28.895 1.966 7.211zm.548.418a.57.57 0 0 1-.548-.418l-3.28.894A3.97 3.97 0 0 0 7.232 24.2zm.568-.568a.57.57 0 0 1-.568.568v3.4a3.97 3.97 0 0 0 3.968-3.968zM7.8 14v6.232h3.4V14z"
                :mask="`url(#${maskId})`" />
        </template>
        <path v-else fill="currentColor" fill-rule="evenodd"
            d="M10.218 14H9.5v6.232a2.268 2.268 0 0 1-4.456.597l-1.967-7.212A5.001 5.001 0 0 1 5 4h5.938l4.511-2.977A1 1 0 0 1 17 1.858v14.76a1 1 0 0 1-1.55.834zM20.595 3.393a.85.85 0 1 0-1.19 1.214A6.13 6.13 0 0 1 21.251 9a6.13 6.13 0 0 1-1.846 4.393.85.85 0 1 0 1.19 1.214A7.83 7.83 0 0 0 22.95 9a7.83 7.83 0 0 0-2.356-5.607"
            clip-rule="evenodd" />
    </svg>
</template>
